// Per-user VPS roster. UI-host endpoints — NOT proxied through to the VPS.
//
// Reverse-WS edition: each row carries a one-time connection_token that
// the engine presents when it dials /_engine on boot. The token is shown
// ONCE — on create + on rotate — and stored as a hash on the server. It
// cannot be recovered later; lose it and the operator rotates. The list
// endpoint reports `engine_connected` so the SPA can paint a live/offline
// pill without any HTTP probing on our end.

import { api } from "./client";

export interface VpsRow {
  id: number;
  label: string;
  created_at: string;
  engine_connected: boolean;
}

export interface VpsRowWithToken {
  id: number;
  label: string;
  created_at: string;
  connection_token: string;
}

export interface CreateVpsRequest {
  label: string;
}

export interface TokenResponse {
  connection_token: string;
}

export const vpsApi = {
  list: () => api<VpsRow[]>("/api/vps"),
  create: (body: CreateVpsRequest) =>
    api<VpsRowWithToken>("/api/vps", { method: "POST", body }),
  remove: (id: number) =>
    api<{ ok: boolean }>(`/api/vps/${id}`, { method: "DELETE" }),
  rotateToken: (id: number) =>
    api<TokenResponse>(`/api/vps/${id}/token-rotate`, { method: "POST" }),
  rename: (id: number, label: string) =>
    api<VpsRow>(`/api/vps/${id}`, { method: "PATCH", body: { label } }),
};
